const Auth = 'Auth';
const Account = 'Account';

export const API_AUTH = {
  API: Auth,
  GENERATE_PASSWORD: `${Auth}/GeneratePassword`,
  LOGIN_WITH_CODE: `${Auth}/LoginWithCode`,
  REFRESH_TOKEN: `${Auth}/RefreshToken`,
  LOGOUT: `${Auth}/Logout`,
  CHECK_AUTH: `${Auth}/CheckAuth`,
};

export const API_ACCOUNT = {
  API: Account,
  GET_CURRENT_APP_USER: `${Account}/GetCurrentAppUser`,
};

export interface AppUser {
  userID: string;
  positionTitle: string;
  picture: string;
  fullName: string;
}
